import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MenuItem } from '@web/shared/ui';
import { CounterBadgeComponent } from '../counter-badge/counter-badge.component';

@Component({
  selector: 'app-account-aside-menu-item',
  imports: [CounterBadgeComponent],
  templateUrl: './account-aside-menu-item.component.html',
  styleUrl: './account-aside-menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountAsideMenuItemComponent {
  public readonly item = input.required<MenuItem>();
}
